"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var EditorTypes_1 = require("../EditorTypes");
var LayoutActions_1 = require("./LayoutActions");
exports.default = (function (di) {
    return [
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("resizeLayoutColumn")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "layout", action: "resizeColumn" })
            .doAction(function (event, editor) {
            (0, LayoutActions_1.resizeLayoutColumn)(editor, event.data.path, {
                columnIndex: event.data.columnIndex,
                distance: event.data.distance,
            });
            return true;
        }),
    ];
});
